import React from 'react';
import { Link } from "react-router-dom";
import { Summary, Delete } from '../../crud/category';
import Swal from 'sweetalert2';
import moment from 'moment';
import { Table, OverlayTrigger, ButtonToolbar, Tooltip, Badge } from "react-bootstrap";
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createBrowserHistory } from 'history';
import Pagination from "react-js-pagination";
require("bootstrap/scss/bootstrap.scss");

const history =  createBrowserHistory();

export default class Category extends React.Component {
  historyEdit(id) {
    history.push("/leaderboard/"+id+"/editEvent");
    window.location.reload();
  }

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingListData: false,
      loadingModal: false,
      totalData: 0,
      totalDataHistory: 0,
      dataEvent:[],
      dataHistory:[],
      postPerPage: 15,
      postPerPageHistory: 5,
      seacrhParams: '',
      seacrhParamsHistory: '',
      orderBy: '',
      orderByHistory: '',
      orderSort: 'asc',
      orderSortHistory: 'desc',
      active: 1,
      activeHistory: 1,
      show: false,
      shows: false,
      showDelete: false,
      params: '',
      eventName: 'test',
      startDate: new Date(),
      endDate: new Date(),
      contentID: '',
      contentEN: '',
      selectedOption: null,
      files: null,
      file_extension: '',
      remaining: 0
    }

    this.handleChange = (fieldName) => (event) => {
      let obj = Object.assign({})
      obj[fieldName] = event.target.value
      obj.resetCapctha = false;
      this.setState(obj)
    }
  }

  handlePageChange = (pageNumber) => {
    let activePage = pageNumber
    this.setState({
      active: activePage
    }, () => {
      this.getSummary(activePage)
    })
  }

  dateTime = date => {
    var date1 = date
    var fmtDate = moment(date1).format('DD-MM-YY hh:m A');

    return fmtDate
  }

  getToken(){
    let token = localStorage.getItem("token")
    return token;
  }

  getSummary(pages = 1) {
    this.setState({
      loading: true
    })

    let params = '';
    if(this.state.orderBy !== ''){
      params = `?order_by=${this.state.orderBy}&order_sort=${this.state.orderSort}&page=${pages}&limit=${this.state.postPerPage}&title=${this.state.seacrhParams}`
    }else{
      params = `?order_sort=${this.state.orderSort}&page=${pages}&limit=${this.state.postPerPage}&title=${this.state.seacrhParams}`
    }

    Summary(this.getToken(), params)
    .then(res => {
      this.setState({
        totalData: res.data.data.total_data,
        dataEvent: res.data.data.data,
        postPerPage: res.data.data.per_page,
        loading: false,
      })
    })
    .catch(e => {
      console.log(e);
      this.setState({
        dataEvent:[],
        loading: true
      })
      if(e.response){
        if(e.response.data.code === 401){
          toast.error("token has expired");
          localStorage.clear();
          history.push("/auth");
          window.location.reload();
        }
        else{
          toast.error(`error code: ${e.response.data.code} message: ${e.response.data.message}`);
        }
      }
    }) 
  }

  componentDidMount(){
    this.getSummary(this.state.active);
  }

  onSortChange = async (name) => {
    
    const { orderSort } = this.state;
    let nextSort;

    if (orderSort === 'desc') nextSort = 'asc';
    if (orderSort === 'asc') nextSort = 'desc';

    await this.setState({
      orderSort: nextSort,
      orderBy: name,
    });
    
    this.getSummary(this.state.active);
  };

  changeSearch = (event) => {
    this.setState({ seacrhParams: event.target.value, active: 1 });
  }

  handleDelete(id){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.delete(id);
      }
    })
  }

  delete(id) {
    this.setState({
      loading: true
    })

    Delete(this.getToken(), id)
    .then(res => {
      this.setState({
        loading: false,
      })
      this.getSummary(this.state.active);
    })
    .catch(e => {
      console.log(e);
      this.setState({
        loading: true
      })
      if(e.response){
        if(e.response.data.code === 401){
          toast.error("token has expired");
          localStorage.clear();
          history.push("/auth");
          window.location.reload();
        }
        else{
          toast.error(`error code: ${e.response.data.code} message: ${e.response.data.message}`);
        }
      }
    }) 
  }

  searchFunction = () => {
    this.getSummary(1);
    this.setState({ active: 1 });
  }

  render(){
    return (
      <div className="head" style={{fontSize: '10px'}}>
        <div className="kt-portlet">
          <div className="kt-portlet__body">
            <div className="kt-portlet__preview">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-start">
                  <input 
                    type="text" 
                    className="form-control mr-3" 
                    name="search" 
                    placeholder="Search" 
                    value={this.state.seacrhParams} 
                    onChange={this.changeSearch} /> 
                  <button className="btn btn-success btn-sm pr-5 pl-5 mr-3" type="button" onClick={() => this.searchFunction()}>Search</button>
                  <Link to="/category/add-category" style={{width: '17%'}}>
                    <button className="btn btn-primary btn-sm mr-3" type="button" style={{width: '100%', padding: '10px'}}>Add new Category</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="kt-portlet">
          <div className="kt-portlet__body pddlessForce">
            <div className="kt-portlet__preview">
              <div className="kt-section">
                <Table striped responsive>
                  <thead>
                    <tr>
                      <th className="tableheh" style={{ width: '4%' }}>
                        No
                      </th>
                      <th className="tableheh" style={{ width: '50%' }}>
                        Title
                        {/* <button onClick={(e) => this.onSortChange('event_name')} className="sort-button">
                          <i className={`fas fa-${sortTypes[this.state.orderSort].class}`} />
                        </button> */}
                      </th>
                      <th className="center tableheh">
                        Status &nbsp;
                      </th>
                      <th className="tableheh">
                        Created At &nbsp;
                      </th>
                      <th className="tableheh">
                        Modified At &nbsp;
                      </th>
                      <th className="center tableheh" style={{width: '10%'}}>Action</th>
                    </tr>
                  </thead>
                  {this.state.loading ? 
                    <tbody>
                      <tr>
                        <td className="center" colSpan="5"><ReactLoading style={{position: 'relative', left: '50%', fill: 'rgb(88, 103, 221)', height: '5%', width: '5%'}} type={'bars'} color={'#5867dd'} height={'5%'} width={'5%'} /></td>
                      </tr>
                    </tbody> :
                    <tbody>
                      {this.state.dataEvent.map((row, index) => (
                        <tr key={index}>
                          <td>{index+1}</td>
                          <td>{row.title_en} / {row.title_id}</td>
                          <td className="center">{row.status === 1 ?
                            <Badge variant="success">
                              Active
                            </Badge>
                            :
                            <Badge variant="danger">
                              Inactive
                            </Badge>
                          }</td>
                          <td>{this.dateTime(row.created_at)}</td>
                          <td>{this.dateTime(row.updated_at)}</td>
                          <td>
                            <ButtonToolbar style={{ justifyContent: 'center'}}>
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    Edit Data
                                  </Tooltip>
                                }
                              >
                                <Link to={`/category/${row.id}/edit-category`} style={{width: '17%'}}>
                                  <span className="btn-action">
                                    <i style={{fontSize: '1rem', paddingRight: '0'}} className="fas fa-pencil-alt text-info" />
                                  </span>
                                </Link>
                              </OverlayTrigger>
                              &nbsp; | &nbsp;
                              <OverlayTrigger
                                placement='top'
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    Delete Data
                                  </Tooltip>
                                }
                              >
                                <span className="btn-action" onClick={() => this.handleDelete(row.id)}>
                                  <i style={{fontSize: '1rem', paddingRight: '0'}} className="fas fa-trash-alt text-danger" />
                                </span>
                              </OverlayTrigger>
                            </ButtonToolbar>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  }
                </Table>
                <div className="d-flex justify-content-center align-items-center pagination-data">
                  <Pagination
                    activePage={this.state.active}
                    itemsCountPerPage={this.state.postPerPage}
                    itemClass="page-item"
                    linkClass="page-link"
                    totalItemsCount={this.state.totalData}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}